import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LeadsGridComponent } from "./leads-grid/leads-grid.component";

const routes: Routes = [
    { path: '', component: LeadsGridComponent },
    // {
    //     path: ':id',
    //     component: CreateEditItemConfigGridComponent,
    //     canActivate: [DialogGuard],
    //     data: { component: CreateEditItemConfigGridComponent },
    // },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class LeadsRoutingModule { }